export const scrollToTop = () => {
  return window.scrollTo(0, 0);
};

/** Theme color used for links and some other interactive elements */
export const linkGreen = '#387A26';

/** Theme color used for tag and some other interactive elements */
export const tagGreen = '#E7F2DA';
export const mandatoryColor = '#EDEBE9';
export const tagBackGroundColor = '#E7F2DA';

/**Theme color used for Status in CDP */
export const completedGreen = '#107C10';
export const inProgressBlue = '#4A87B5';
export const notStartedOrange = '#F7630C';

/** Theme color used for header and description */
export const headerColor = '#323130';
export const textColor = '#605E5C';
